import { Admin, Resource } from "react-admin";
import polyglotI18nProvider from 'ra-i18n-polyglot';
import frenchMessages from 'ra-language-french';

import jsonServerProvider from './Providers/DataProvider';
import { UsersList } from './Pages/Users/UserList';
import { UserCreate } from './Pages/Users/UserCreate';
import { UserEdit } from './Pages/Users/UserEdit';
import { ResiliationCategoryList } from './Pages/ResiliationCategory/ResiliationCategoryList';
import { ResiliationCategoryCreate } from './Pages/ResiliationCategory/ResiliationCategoryCreate';
import { ResiliationCategoryEdit } from './Pages/ResiliationCategory/ResiliationCategoryEdit';
import authProvider from './Providers/AuthProvider';
import CustomLayout from './Components/CustomLayout';
import { ResiliationModelsList } from "./Pages/ResiliationModel/ResiliationModelList";
import { ResiliationModelCreate } from "./Pages/ResiliationModel/ResiliationModelCreate";
import { ResiliationModelEdit } from "./Pages/ResiliationModel/ResiliationModelEdit";
import { ClientsList } from "./Pages/Clients/ClientList";
import { ClientShow } from "./Pages/Clients/ClientShow";
import { LegalPapersList } from "./Pages/LegalPaper/LegalPaperList";
import { LegalPaperCreate } from "./Pages/LegalPaper/LegalPaperCreate";
import { LegalPaperEdit } from "./Pages/LegalPaper/LegalPaperEdit";

const i18nProvider = polyglotI18nProvider(() => frenchMessages, 'fr');

const App = () => (
  <Admin
    i18nProvider={i18nProvider}
    authProvider={authProvider}
    dataProvider={jsonServerProvider}
    layout={CustomLayout}>
    {permissions => [
      (permissions === 'Admin' || permissions === 'SuperAdmin') && <Resource options={{ label: 'Clients', isAdmin: true }} name="Admin" list={ClientsList} show={ClientShow} />,
      permissions === 'SuperAdmin' && <Resource options={{ label: 'Documents légaux', isSuperAdmin: true }} name="LegalPapers" list={LegalPapersList} create={LegalPaperCreate} edit={LegalPaperEdit}/>,
      permissions === 'SuperAdmin' && <Resource options={{ label: 'Catégories', isSuperAdmin: true }} name="ResiliationCategory" list={ResiliationCategoryList} create={ResiliationCategoryCreate} edit={ResiliationCategoryEdit}/>,
      permissions === 'SuperAdmin' && <Resource options={{ label: 'Modèles', isSuperAdmin: true }} name="ResiliationModel" list={ResiliationModelsList} create={ResiliationModelCreate} edit={ResiliationModelEdit}/>,
      permissions === 'SuperAdmin' && <Resource options={{ label: 'Utilisateurs', isSuperAdmin: true }} name="AdminUser" list={UsersList} create={UserCreate} edit={UserEdit} />
    ]}
  </Admin>
);

export default App;